import type { ReactElement } from 'react';

import { useOnline } from '../../hooks/useOnline.js';
import styles from './AppShell.module.css';

export function OfflineBanner(): ReactElement | null {
    const online = useOnline();
    if (online) {
        return null;
    }
    return (
        <p className={styles.offline} role="status">
            You are offline. Saving a record needs a connection.
        </p>
    );
}
